import fetch from "auth/FetchInterceptor";
import { API_BASE_URL } from "configs/AppConfig";

const BASE_URL = API_BASE_URL;


export function requestRentalInvoiceBillsList(params) {
  if (params === undefined) {
    return fetch.get(`${BASE_URL}/api/app/rental-master`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  } else {
    return fetch.get(`${BASE_URL}/api/app/rental-master?${params}`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  }
}

export function requestRentalInvoiceBillsCreate(data) {
  return fetch.post(`${BASE_URL}/api/app/rental-master`, data);
}

export function requestRentalInvoiceBillsUpdate(data) {
  const body = { ...data };
  delete body["_id"];
  return fetch.put(`${BASE_URL}/api/app/rental-master/${data._id}`, body);
}

export function requestDeleteRentalItem(data) {
  const body = { ...data }
  delete body["_id"]
  return fetch.delete(`${BASE_URL}/api/app/rental-master/${data._id}`, body)
}

export function requestRentalReportUpdateStatus(data) {
  const body = { data };
  delete body["_id"];
  return fetch.put(`${BASE_URL}/api/app/rental-bill/update/list`, data);
}

// rental bills list
export function requestRentalBillsList(params) {
  if (params === undefined) {
    return fetch.get(`${BASE_URL}/api/app/rental-bill`, {
      // params: { limit: Number.MAX_SAFE_INTEGER },
    });
  } else {
    return fetch.get(`${BASE_URL}/api/app/rental-bill?${params}`, {
      // params: { limit: Number.MAX_SAFE_INTEGER },
    });
  }
}

export function requestRentalBillsCreate(data) {
  return fetch.post(`${BASE_URL}/api/app/rental-bill`, data);
}

export function requestRentalBillsUpdate(data) {
  const body = { ...data };
  delete body["_id"];
  return fetch.put(`${BASE_URL}/api/app/rental-bill/${data._id}`, body);
}